import React from 'react';
import { Modal, Card, Button, Space } from 'antd';
import { UserOutlined, BankOutlined, GlobalOutlined } from '@ant-design/icons';
import { CUSTOMER_TYPES, CUSTOMER_TYPE_DESCRIPTIONS, type CustomerType } from '@/constants/customer';

interface CustomerTypeModalProps {
  visible: boolean;
  onCancel: () => void;
  onSelectType: (type: CustomerType) => void;
}

const CustomerTypeModal: React.FC<CustomerTypeModalProps> = ({
  visible,
  onCancel,
  onSelectType,
}) => {
  return (
    <Modal
      title="选择客户类型"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      centered
      maskClosable={false}
    >
      <div style={{ padding: '20px 0' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '20px',
          justifyContent: 'center'
        }}>
          <Card
            hoverable
            style={{ textAlign: 'center' }}
            onClick={() => onSelectType(CUSTOMER_TYPES.PERSONAL)}
          >
            <div style={{ padding: '20px 0' }}>
              <UserOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
              <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
                {CUSTOMER_TYPES.PERSONAL}
              </div>
              <div style={{ color: '#666', fontSize: '14px' }}>
                {CUSTOMER_TYPE_DESCRIPTIONS[CUSTOMER_TYPES.PERSONAL]}
              </div>
            </div>
          </Card>

          <Card
            hoverable
            style={{ textAlign: 'center' }}
            onClick={() => onSelectType(CUSTOMER_TYPES.INSTITUTIONAL)}
          >
            <div style={{ padding: '20px 0' }}>
              <BankOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
              <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
                {CUSTOMER_TYPES.INSTITUTIONAL}
              </div>
              <div style={{ color: '#666', fontSize: '14px' }}>
                {CUSTOMER_TYPE_DESCRIPTIONS[CUSTOMER_TYPES.INSTITUTIONAL]}
              </div>
            </div>
          </Card>

          <Card
            hoverable
            style={{ textAlign: 'center' }}
            onClick={() => onSelectType(CUSTOMER_TYPES.EXTERNAL)}
          >
            <div style={{ padding: '20px 0' }}>
              <GlobalOutlined style={{ fontSize: '48px', color: '#fa8c16', marginBottom: '16px' }} />
              <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
                {CUSTOMER_TYPES.EXTERNAL}
              </div>
              <div style={{ color: '#666', fontSize: '14px' }}>
                {CUSTOMER_TYPE_DESCRIPTIONS[CUSTOMER_TYPES.EXTERNAL]}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </Modal>
  );
};

export default CustomerTypeModal;
